import { Button } from '@components/ui/Button/Button';
import { Title } from '@components/ui/Title/Title';
import DataTrends from 'public/illustrations/data-trends.svg';
import React from 'react';

import styles from './Steps.module.scss';

interface IntroStepProps {
  onStart: () => void;
}

export const IntroStep: React.FC<IntroStepProps> = ({ onStart }) => (
  <div className={styles.wrapper}>
    <div className={styles.content}>
      <div className={styles.label}>Calvin Tour</div>
      <Title
        className={styles.title}
        htmlElement="h2"
      >
        Welcome to Calvin Risk
      </Title>
      <p>
        Calvin Risk helps you understand and manage the risk of your AI models — from data collection to assessment and
        reporting.
      </p>
      <p>This short tour covers the key areas of the platform. Each video is 1–5 minutes.</p>
      <Button
        view="primary"
        className={styles.button}
        onClick={onStart}
      >
        Start tour
      </Button>
    </div>
    <div className={styles.illustration}>
      <DataTrends />
    </div>
  </div>
);
